import {
  Button,
  Container,
  createStyles,
  Group,
  rem,
  Text,
  Title,
} from "@mantine/core";
import { useNavigate } from "react-router-dom";

const useStyles = createStyles(theme => ({
  root: {
    paddingTop: rem(80),
    paddingBottom: rem(80),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    textAlign: "justify",
  },

  label: {
    textAlign: "center",
    fontWeight: 900,
    fontSize: rem(220),
    lineHeight: 1,
    marginBottom: `calc(${theme.spacing.xl} * 1.5)`,
    color:
      theme.colorScheme === "dark"
        ? theme.colors.dark[4]
        : theme.colors.gray[2],

    [theme.fn.smallerThan("sm")]: {
      fontSize: rem(120),
    },
  },

  title: {
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    textAlign: "center",
    fontWeight: 900,
    fontSize: rem(38),

    [theme.fn.smallerThan("sm")]: {
      fontSize: rem(32),
    },
  },

  description: {
    maxWidth: rem(500),
    margin: "auto",
    marginTop: theme.spacing.xl,
    marginBottom: `calc(${theme.spacing.xl} * 1.5)`,
  },
}));

function ErrorPage() {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const handleReset = () => {
    navigate("/home");
    window.location.reload();
  };

  return (
    <>
      <Container className={classes.root}>
        <div className={classes.label}>Error</div>
        <Title className={classes.title}>
          An unexpected error has occurred
        </Title>
        <Text
          color="dimmed"
          size="lg"
          align="center"
          className={classes.description}>
          We apologize, but an unexpected error has occurred on our website. Our
          technical team is already working to resolve it. Please try refreshing
          the page or returning to the previous page. If the issue persists,
          contact our support team and provide details about when the error
          occurred. Thank you for your patience as we work to fix this.
        </Text>
        <Group position="center">
          <Button onClick={handleReset} variant="subtle" size="md">
            Go back to home page
          </Button>
        </Group>
      </Container>
    </>
  );
}

export default ErrorPage;
